import Vue from 'vue';

export default {
    all() {
        return Vue.axios.get('topic/topic-category-tree');
    }
};
